<template>
  
  <div>
    
    <TodoEditModal
      ref="todo-editor"
      :todo="selected_todo"
      @updated="todo_updated"
      @published="todo_published"
    />

    <m-row v-if="type === 'draft'">
      <m-col lg="8">
        <memlist-text-input
          id="search_first"
          name="search_first"
          layout="vertical"
          placeholder="Sök ärende"
          style="min-width: 380px;"
          v-model="search"
        />

      </m-col>
      <m-col lg="4" class="d-flex justify-content-end">
        <memlist-icon-button
          class="mb-2"
          icon="menu-icon flaticon2-plus"
          :text="$t('TODO.NEW')"
          variant="primary"
          @click="create_todo_clicked"
        />
        
      </m-col>
    </m-row>
    
    <m-row>
      <m-col>
        <memlist-text-input
          v-if="type !== 'draft'"
          id="search_second"
          name="search_second"
          layout="vertical"
          placeholder="Sök ärende"
          style="min-width: 380px;"
          v-model="search"
        />
      </m-col>
    </m-row>
    

    <m-row>
      <m-col cols="6" style="align-content: end;">
        <div class="bottom-alignment">
          <strong>{{ $t('MEMBER.NUM_ROWS') }}:</strong> {{ total_rows }}
        </div>

      </m-col>
      <m-col cols="6">
        
        <div class="d-sm-flex justify-content-end align-items-right align-bottom w-100 mb-2">
          <memlist-pagination 
            :per_page="per_page" 
            :total_rows="total_rows" 
            @page-changed="current_page = $event"
            @per-page-changed="per_page = $event"
          />

        </div>

      </m-col>
    </m-row>

    <memlist-ajax-table
      ref="todo-table"
      :fields="todo_headers"
      :items="ajax_pagination"
      :per_page="per_page"
      :current_page="current_page"
      @sort-changed="on_sort_changed"
    >
    
      <template #cell(status)="{ item }">
        {{ statusName[item.status] }}
      </template>
      <template #cell(action)="{ item }">

        <memlist-table-button class="mr-2" v-if="type !== 'draft'" @click="show_comments_clicked(item.todo_id)" svg="/assets/svg/chat.svg" tooltip="Visa kommentarer" />
        <memlist-table-button class="mr-2" @click="select_todo_clicked(item.todo_id)" svg="/assets/svg/pencil-square.svg" :tooltip="$t('COMMON.EDIT')"/>
        <memlist-table-button @click="delete_todo_clicked(item.todo_id)" svg="/assets/svg/trash2.svg" :tooltip="$t('COMMON.DELETE')" />

      </template>
    </memlist-ajax-table>
    
  </div>
  
</template>
<script>
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import axios from 'axios';
import { mapGetters } from 'vuex';
import TodoEditModal from '@/view/pages/ml/todo/TodoEditModal.vue';


export default {
  name: 'TodoTable',
  props: ['todos', 'type', 'statusName'],
  emits: ['show_comments_clicked', 'showChildren'],
  mixins: [ toasts ],
  components: {
    TodoEditModal,
  },
  data() {
    return {
      selected_todo: {},
      order_by_col: 'todo_id',
      order_by_dir: 'desc',
      headerProps: {
        sortByText: 'Sortera'
      },
      expanded: {},
      list: [],
      search: '',
      current_page: 1,
      per_page: 100,
      total_rows: 0,
      title: '',
    };
  },
  watch: {
    search() {
      this.$refs['todo-table'].refresh();
    }
  },
  methods: {
    todo_updated(todo) {
      this.$refs['todo-table'].refresh();
    },
    todo_published(todo) {
      this.$refs['todo-table'].refresh();

      this.$emit('published', todo);
    },
    
    show_comments_clicked(todo_id) {
      this.$emit('show_comments_clicked', todo_id);
    },
    async select_todo_clicked(todo_id) {
      this.selected_todo = await this.fetch_todo(todo_id);

      this.$nextTick(()=>{
        this.$refs['todo-editor'].show();
      });
    },

    async fetch_todo(todo_id) {
      const res = await axios.get(`/todo/${todo_id}`);

      if (res.status === 200) {
        return res.data;
      }

      return null;
    },

    async delete_todo_clicked(todo_id) {
      const res = await axios.delete(`/todo/${todo_id}`);

      if (res.status === 204) {
        this.$refs['todo-table'].refresh();
      }
    },
    showChildren(todo_id, show) {
      this.$emit('showChildren', todo_id, show);
    },
    create_todo_clicked() {
      this.$emit('create_todo_clicked');
    },


    on_sort_changed(sortChanged) {

      if (sortChanged.sortBy === '') {
        this.order_by_col = sortChanged.sortBy;
      }
      else {
        this.order_by_col = sortChanged.sortBy;
        this.order_by_dir = sortChanged.sortDesc ? 'desc' : 'asc';
      }
    },

    get_search_param() {
      if (this.search) {
        return `&search=${this.search}`;
      }

      return '';
    },

    ajax_pagination: function(ctx, callback) {
      const vm = this;

      let params = {
        pageNo: ctx.current_page,
        pageSize: ctx.per_page,
        flag: 0,
        po: vm.searchOrderNumber,
        styNum: vm.searchStyleNumber
      };

      this.load_pagination(callback);

      return null;
    },

    async load_pagination(callback) {

      try {

        const statuses = [
          //'WAIT',
          'DRAFT',
          //'NOT',
          //'DONE',
          //'CN',
          //'DEL',
          //'ACC',
          //'REJ',
          //'BAC',
          //'FUT',
          //'CLOSE',
          //'INVALID',
        ];

        const res = await axios.get(`/todo?type=PA&creator_company_id=${this.currentCompanyId}${this.get_search_param()}&order_by_col=${this.order_by_col}&dir=${this.order_by_dir}&page=${this.current_page}&limit=${this.per_page}&statuses=${encodeURIComponent('[' + statuses.map(x => `"${x}"`).join(',') + ']')}`);

        if (res.status === 200) {
          this.total_rows = res.data.count;
          callback(res.data.todos || []);
        }
      }
      catch (err) {
        console.error('pagination error', err);
      }
    },

  },
  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId']),
  
    todo_headers() {
      return [
        { 
          tdClass: 'td-overflow3',
          thClass: 'td-overflow3',
          label: this.type === 'draft' ? 'Ärendenamn' : 'Förening', 
          key: 'name' 
        },
        { 
          thClass: 'td-short3', 
          tdClass: 'td-short3', 
          label: 'Status', 
          key: 'status' 
        },
        { 
          label: 'Från Datum', 
          key: 'from_datetime' 
        },
        { 
          label: 'Till Datum', 
          key: 'to_datetime' 
        },
        { 
          label: '', 
          key: 'action',
          thClass: 'td-short4', 
          tdClass: 'td-short4', 
        },
      ]
    },
  },
  
};
</script>

<style lang="scss" scoped>


  .card.card-custom > .card-body {
    padding: 0 !important;
  }
  .card.card-custom > .card-header {
    padding: 0 !important;
  }
  .checkbox > span {
    background-color: white;
    border: 1px solid #ddd;
  }
  .hplus {
    cursor: pointer;
  }
  .hminus {
    cursor: pointer;
  }

</style>
